import { render, staticRenderFns } from "./currentfilerightclick.vue?vue&type=template&id=508d4815&"
import script from "./currentfilerightclick.vue?vue&type=script&lang=js&"
export * from "./currentfilerightclick.vue?vue&type=script&lang=js&"
import style0 from "./currentfilerightclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports